
export enum CMPCommands {
    GET_VENDOR_CONSENTS = 'getVendorConsents',
    GET_CONSENT_DATA = 'getConsentData',
    GET_PUBLISHER_CONSENTS = 'getPublisherConsents',
    GET_VENDOR_LIST = 'getVendorList',
    DECODE_CONSENT_STRING = 'decodeConsentString',
    PING = 'ping'
}